import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Field, reduxForm } from 'redux-form';
import _ from 'lodash';
import { Button, Modal } from 'reactstrap';

// constant
import { DEVELOPMENT_TYPE, LABEL_POSITION_TOP } from '../Common/constant';
import LocalStrings from '../../languages';
import { renderFieldText, validateEmail } from '../Common/base-components';
import { showSuccess, showError, showWarning } from '../Common/alertmessage';

// actions
import {
  loginModal,
  signupModal,
  mainLogin,
  forgotPasscode
} from '../../actions';

// components
import CourseCheckout from './course-checkout';
import SessionCheckout from './session-checkout';

const Login = props => {
  let { session, isLoggedIn, modalStatus, handleSubmit } = props;
  const [doPurchase, setPurchase] = useState(false);
  const [loading, setLoading] = useState(false);
  const [forgotLayout, setForgotLayout] = useState(false);
  // console.log('login modalStatus :- ', modalStatus);

  useEffect(() => {
    if (isLoggedIn == true && modalStatus.purchaseType) {
      setPurchase(true);
    }
  }, []);

  const closeModal = () => {
    props.loginModal({ showModal: false });
    setPurchase(false);
  };

  const openSignupModal = () => {
    closeModal();

    if (isLoggedIn == false && modalStatus.purchaseType) {
      props.signupModal({
        showModal: true,
        purchaseType: modalStatus.purchaseType,
        details: modalStatus.details
      });
    } else {
      props.signupModal({ showModal: true });
    }
  };

  const onSubmitForm = values => {
    setLoading(true);
    var alsoPurchase =
      modalStatus.purchaseType && modalStatus.purchaseType != ''
        ? modalStatus.purchaseType
        : '';
    let email = values.email.toLowerCase();

    if (forgotLayout) {
      let reqObj = {
        email: email,
        eventid: session.eventid,
        isadmin: 1
      };

      props.forgotPasscode(session, reqObj, res => {
        if (res.success) {
          showSuccess(res.data?.result);
          setForgotLayout(false);
        } else {
          showError(res?.message?.message);
        }
        setLoading(false);
      });
    } else {
      let obj = {
        email: email,
        password: values.password
      };

      props.mainLogin(session, obj, alsoPurchase, response => {
        // console.log('login response in call back', response);
        setLoading(false);
        if (response.success === 0) {
          // ----- wrong creds
          showError(LocalStrings.login_error_text_invalid_email_password);
        } else if (response.success === 2) {
          // ----- !admin & !registered
          showError(LocalStrings.kEmailNotRegistered);
        } else if (response.success === 3) {
          if (response.type === 'waitlist') {
            showWarning(LocalStrings.login_error_text_user_on_waitlist);
          } else if (response.type === 'user-deactivated') {
            showWarning(LocalStrings.kValidityExpireMessage);
          } else if (response.type === 'not-registered') {
            showWarning(LocalStrings.kEmailNotRegistered);
          } else if (response.type === 'attendee-site-restriction') {
            showWarning(LocalStrings.kEventNotStarted);
          } else {
            showError(response.message);
          }
        } else {
          // ----- login success

          if (modalStatus.purchaseType && modalStatus.purchaseType != '') {
            var myAccess = [];
            if (modalStatus.purchaseType === 'course') {
              myAccess = response.data.mycourse;
            } else {
              myAccess = response.data.mysession;
            }
            var matched = _.filter(myAccess, obj => {
              return obj.courseid === modalStatus.details.courseid;
            });

            if (matched.length > 0) {
              closeModal();
            } else {
              setPurchase(true);
            }
          } else {
            closeModal();
          }
        }
      });
    }
  };

  return (
    <>
      <Modal
        className="login-modal"
        isOpen={modalStatus && modalStatus.showModal == true ? true : false}
        centered
      >
        <div className="modal-header">
          <div className="modal-title custom-text2-medium-primary">
            {doPurchase
              ? LocalStrings.checkout_title_checkout
              : LocalStrings.kLoginText}
          </div>
          <button
            aria-label="Close"
            className="close"
            data-dismiss="modal"
            type="button"
            onClick={() => closeModal()}
          >
            <span aria-hidden={true}>×</span>
          </button>
        </div>
        <div className="modal-body">
          {doPurchase == true ? (
            <div>
              {modalStatus.purchaseType === 'course' ? (
                <CourseCheckout
                  printList={modalStatus.details}
                  history={props.history}
                  closeModal={closeModal}
                />
              ) : (
                <SessionCheckout
                  printList={modalStatus.details}
                  history={props.history}
                  closeModal={closeModal}
                />
              )}
            </div>
          ) : (
            <div>
              <div className="custom-text5-bold mb-3">
                <span className="custom-text-color">//</span>{' '}
                {LocalStrings.kLoginText}
              </div>
              <form onSubmit={handleSubmit(onSubmitForm)}>
                <Field
                  name="email"
                  label={LocalStrings.kYourEmailAddress}
                  placeholder={
                    !forgotLayout
                      ? LocalStrings.form_ph_email
                      : LocalStrings.login_enter_registered_email
                  }
                  type="text"
                  component={renderFieldText}
                  labelposition={LABEL_POSITION_TOP}
                />
                {!forgotLayout ? (
                  <>
                    <Field
                      name="password"
                      label={LocalStrings.login_form_label_password}
                      placeholder={LocalStrings.login_form_ph_password}
                      type="password"
                      component={renderFieldText}
                      labelposition={LABEL_POSITION_TOP}
                    />
                  </>
                ) : (
                  ''
                )}
                <Button
                  type="submit"
                  className="custom-button-primary-lg w-100"
                  disabled={loading}
                >
                  <i className={loading ? `fa fa-refresh fa-spin` : ''}></i>
                  &ensp;
                  {!forgotLayout
                    ? LocalStrings.kLoginText
                    : LocalStrings.login_resend_welcome_mail}
                </Button>

                <div
                  className="mt-1"
                  style={{ display: 'grid', justifyItems: 'end' }}
                >
                  <div
                    className="custom-text8-medium"
                    style={{ cursor: 'pointer' }}
                    onClick={() => setForgotLayout(true)}
                  >
                    <span>{LocalStrings.login_forgot_pass_code}</span>
                  </div>
                </div>
              </form>

              {DEVELOPMENT_TYPE === 'koachify' ? (
                <div className="mt-4">
                  <div className="float-left custom-link1"></div>
                  <div className="float-right">
                    <span className="custom-text1-medium">
                      {LocalStrings.login_text_dont_have_account}
                    </span>{' '}
                    <span className="custom-link1" onClick={openSignupModal}>
                      {LocalStrings.button_signup}
                    </span>
                  </div>
                </div>
              ) : (
                ''
              )}
            </div>
          )}
        </div>
      </Modal>
    </>
  );
};

const validate = values => {
  var errors = {};
  var email = values['email'];
  var password = values['password'];

  if (!email || email.trim() === '') {
    errors['email'] = LocalStrings.requird;
  } else if (email && !validateEmail(email)) {
    errors['email'] = LocalStrings.invalid_email;
  }
  if (!password || password.trim() === '') {
    errors['password'] = LocalStrings.requird;
  }

  return errors;
};

const mapStateToProps = state => ({
  isLoggedIn: state.isLoggedIn,
  session: state.session,
  modalStatus: state.loginModal
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      loginModal,
      signupModal,
      mainLogin,
      forgotPasscode
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  reduxForm({
    validate,
    form: 'LoginForm'
  })(Login)
);
